import { ReactNode, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import MobileBottomNav from './MobileBottomNav'
import { OfflineIndicator } from './OfflineIndicator'
import { PWAInstallPrompt } from './PWAInstallPrompt'

interface LayoutProps {
  children: ReactNode
}

import { isFullscreenLayoutPath } from '@/utils/publicPaths'
import { useEscalationNotifications } from '@/hooks/useEscalationNotifications'

export { isFullscreenLayoutPath }

export function isFullWidthLayoutPath(pathname: string) {
  return pathname.startsWith('/app/conversations')
}

export default function Layout({ children }: LayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const location = useLocation()

  // Alertas en tiempo real para vendedores de casos escalados por IA
  useEscalationNotifications()

  // Don't show sidebar on public pages
  const isFullscreenPage = isFullscreenLayoutPath(location.pathname)
  const isFullWidthPage = isFullWidthLayoutPath(location.pathname)

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  const closeSidebar = () => {
    setIsSidebarOpen(false)
  }

  return (
    <div className={isFullWidthPage ? 'h-screen flex flex-col overflow-hidden bg-gray-50' : 'min-h-screen bg-gray-50'}>
      <OfflineIndicator />
      <PWAInstallPrompt />
      {!isFullscreenPage && (
        <>
          <Header onMenuClick={toggleSidebar} />
          <div className={isFullWidthPage ? 'flex flex-1 min-h-0 overflow-hidden' : 'flex'}>
            <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
            {isFullWidthPage ? (
              <main className="flex-1 min-w-0 w-full h-full overflow-hidden">
                <div className="w-full h-full overflow-hidden">
                  {children}
                </div>
              </main>
            ) : (
              <main className="flex-1 py-4 sm:py-6 lg:ml-0 overflow-x-hidden pb-20 lg:pb-6">
                <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-6 xl:px-8 w-full">
                  {children}
                </div>
              </main>
            )}
          </div>
          <MobileBottomNav />
        </>
      )}
      {isFullscreenPage && (
        <main className="w-full">
          {children}
        </main>
      )}
    </div>
  )
}
